export const ShortHideIcon = (): JSX.Element => {
  return (
    <div className="flex text-primary-3.0 -ml-1.5">
      <i className="icon-chevron_right_icon w-2 my-auto font-semibold" />
      <i className="icon-chevron_right_icon w-2 my-auto font-semibold" />
    </div>
  );
};
